import React, { useState } from "react";
import { Button, Form, } from "react-bootstrap";
import "./Login.css";

export const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  function validateForm() {
    return email.length > 0 && password.length > 0;
  }

  function handleSubmit(event) {
    event.preventDefault();
  }

  return (
    <div className="Login">
      <Form onSubmit={handleSubmit}>
        <Form.Group controlId="email" bsSize="large">
          <Form.Label className="label">Email</Form.Label>
          <Form.Control
            className="control"
            autoFocus
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
          />
        </Form.Group>
        <Form.Group controlId="password" bsSize="large">
          <Form.Label className="label">Password</Form.Label>
          <Form.Control className="control"
            value={password}
            onChange={e => setPassword(e.target.value)}
            type="password"
          />
        </Form.Group>
        <div className="center">
          <Button block className="loginButton" bsSize="large" disabled={!validateForm()} type="submit">
            Login
          </Button>
        </div>
      </Form>
      </div>
  );
}